import React from 'react';
import PropTypes from 'prop-types';
import { Heading_1 as Heading1, PrimaryButton } from '@huggg/react-components';
import dictionary from 'config/dictionary';
import errorIcon from 'assets/img/error.svg';
import BackButton from '../../BackButton/BackButton';
import styles from '../bankPaymentRedemption.module.scss';

export const NameMismatchView = ({ onTryAgain, isLoading }) => (
  <div
    className={styles.container}
    data-test-id="bank-payment-name-mismatch-view"
  >
    <img
      className={styles.errorIcon}
      src={errorIcon}
      alt=""
      aria-hidden="true"
    />
    <div className={styles.header}>
      <Heading1>{dictionary.bankPayment.labels.nameMismatchTitle}</Heading1>
    </div>
    {dictionary.bankPayment.copy.nameMismatchBody.map((paragraph) => (
      <p key={paragraph} className={styles.body}>
        {paragraph}
      </p>
    ))}
    <div className={`${styles.ctaWrapper} ${styles.ctaWrapperSpaced}`}>
      <PrimaryButton
        onClick={onTryAgain}
        label={
          isLoading
            ? dictionary.bankPayment.labels.connectingCta
            : dictionary.bankPayment.labels.tryAgainCta
        }
        disabled={isLoading}
        className={styles.cta}
        data-test-id="bank-payment-name-mismatch-cta"
      />
    </div>
    <BackButton className={styles.backButton} />
  </div>
);

NameMismatchView.propTypes = {
  onTryAgain: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

export default NameMismatchView;
